import { Component, Input } from '@angular/core';

@Component({
    selector: 'sgt-campanha-pipeline-card-info-vigencia',
    templateUrl: './campanha-pipeline-card-info-vigencia.component.html',
    styleUrls: ['./campanha-pipeline-card-info-vigencia.component.less']
})
export class CampanhaPipelineCardInfoVigenciaComponent {
    @Input() isNaoConfirmada: boolean;
    @Input() isEmAnalise: boolean;
    @Input() isEmAndamento: boolean;
    @Input() isEmRevisao: boolean;
    @Input() isEncerrada: boolean;
    @Input() isReprovada: boolean;

    @Input() sobDemandaPacoteCampanha: boolean;
    @Input() vigenciaRecorrente: boolean;
    @Input() quantidadeDiasVigencia: number;
    @Input() dataTerminoVigencia: Date;
    @Input() dataInicioAndamento: Date;
    @Input() dataTerminoAndamento: Date;
}
